import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export const StatCard = ({ 
  title, 
  value, 
  subtitle, 
  trend, 
  trendValue, 
  icon: Icon, 
  color = 'continental',
  href = null 
}) => {
  const colorClasses = {
    continental: 'bg-continental/10 text-continental',
    gold: 'bg-tradeGold/10 text-tradeGold-foreground',
    blue: 'bg-oceanBlue/10 text-oceanBlue',
    orange: 'bg-logistics/10 text-logistics',
  };

  const getTrendIcon = () => {
    if (trend === 'up') return <TrendingUp className="w-4 h-4 text-green-500" />;
    if (trend === 'down') return <TrendingDown className="w-4 h-4 text-red-500" />;
    return <Minus className="w-4 h-4 text-gray-400" />;
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'text-green-600';
    if (trend === 'down') return 'text-red-600';
    return 'text-gray-500';
  };

  const CardWrapper = href ? Link : 'div';
  const wrapperProps = href ? { to: href } : {};

  return (
    <CardWrapper {...wrapperProps} className={href ? 'block' : ''}>
      <Card className={`card-interactive ${href ? 'cursor-pointer hover:border-continental hover:shadow-lg transition-all' : ''}`} data-testid={`stat-card-${title.toLowerCase().replace(/\s/g, '-')}`}>
        <CardContent className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${colorClasses[color]}`}>
              {Icon && <Icon className="w-6 h-6" />}
            </div>
            {trend && (
              <div className={`flex items-center gap-1 text-sm font-medium ${getTrendColor()}`}>
                {getTrendIcon()}
                {trendValue}
              </div>
            )}
          </div>
          <div>
            <p className="text-3xl font-bold text-charcoal font-poppins">{value}</p>
            <p className="text-sm text-gray-500 mt-1">{title}</p>
            {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
          </div>
        </CardContent>
      </Card>
    </CardWrapper>
  );
};

export default StatCard;
